import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import styles from './styles.module.scss';
import { Typography } from '@mui/material';
import { NewSolutionInputs } from './NewSolutionInputs/NewSolutionInputs';
import { useTranslation } from 'react-i18next';
export function NewSolution() {
    const { t } = useTranslation();
    return (_jsxs("div", { className: styles.container, children: [_jsx(Typography, { className: styles.title, children: t('New Solution') }), _jsx(NewSolutionInputs, {})] }));
}
